export default "__VITE_ASSET___JvYogaM__"